































import { Component, Prop } from 'vue-property-decorator';
import Multiselect from 'vue-multiselect';
import Avatar from '@/components/common/Avatar.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { CheckIcon } from 'vue-feather-icons';
import { IRole } from 'admiral-core';
import { Util } from '@/utils/Util';

@Component({
  components: { Multiselect, Avatar, CheckIcon },
})
export default class RoleSelect extends mixins(BaseMixin) {
  @Prop({ type: Boolean, default: () => false })
  multiple!: boolean;

  @Prop()
  role!: IRole | IRole[];

  get options() {
    return this.$store.state.DataModule.roles;
  }

  updateRole(role: IRole | IRole[]) {
    this.$emit('update-role', role);
  }

  isSelected(id: string) {
    if (Array.isArray(this.role)) {
      return this.role.find((role: IRole) => role.id === id);
    } else {
      return this.role.id === id;
    }
  }
  roleLabel(role: IRole) {
    return Util.formatUserRoleName(role);
  }
  roleDescription(role: IRole) {
    switch (role.name) {
      case 'Admin':
        return 'Darf neue Mitarbeiter und Mitarbeiterinnen anlegen und alles was in "Manager/in" fällt.';
      case 'Manager':
        return 'Darf eigene und Anbahnungen von Mitarbeitern anlegen und bearbeiten. Darf Geschäftsplan einsehen und hochladen.';
      case 'Employee':
        return 'Darf eigene Anbahnungen anlegen und bearbeiten.';
      case 'Guest':
        return 'Gast';
      default:
        return '-';
    }
  }
}
